/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiPlatformFromJSON, ApiPlatformToJSON, } from './ApiPlatform';
export function ApiSignupAuthPayloadFromJSON(json) {
    return ApiSignupAuthPayloadFromJSONTyped(json, false);
}
export function ApiSignupAuthPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'code': !exists(json, 'code') ? undefined : json['code'],
        'platform': !exists(json, 'platform') ? undefined : ApiPlatformFromJSON(json['platform']),
        'redirectUrl': !exists(json, 'redirectUrl') ? undefined : json['redirectUrl'],
        'shop': !exists(json, 'shop') ? undefined : json['shop'],
        'storeUrl': !exists(json, 'storeUrl') ? undefined : json['storeUrl'],
    };
}
export function ApiSignupAuthPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'code': value.code,
        'platform': ApiPlatformToJSON(value.platform),
        'redirectUrl': value.redirectUrl,
        'shop': value.shop,
        'storeUrl': value.storeUrl,
    };
}
